import React from 'react';
import ProjectContent from '../components/ProjectContent';

const Dindle = () => <ProjectContent projectName='Dindle'/>;

export default Dindle;